import { getHandleConnections } from '@common-reducers/ChatbotSelectors';
import { useAppSelector } from '@common-reducers/hooks/store.hook';
import React, { ComponentProps, useEffect, useState } from 'react';
import { Handle } from 'reactflow';


type CustomSourceHandleProps = ComponentProps<typeof Handle> & {
    connectioncount: number;
};

const CustomSourceHandle = (props: CustomSourceHandleProps) => {
    const connections = useAppSelector(state => getHandleConnections(state, props.id ?? ''))
    const [isConnectable, setIsConnectable] = useState(true);

    useEffect(() => {
        setIsConnectable((connections?.length ?? 0) < props.connectioncount);
    }, [connections, props.connectioncount]);

    return (
        <Handle
            {...props}
            isConnectable={isConnectable}
        />
    );
};

export default CustomSourceHandle;
